import { memo } from 'react';
import styled from 'styled-components';

import { getFlagURIByCountryCode } from '@utils/index';

const Image = styled.img<{ $width: number; $height: number }>`
  border-radius: 6px;
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};

  box-shadow: 2px 2px 4px 0
    ${({ theme }) => `${theme.colors.black}${theme.opacity[40]}`};
`;

type Props = {
  size?: { width: number; height: number };
  country?: string;
};

const WIDTH = 60;
const HEIGHT = 40;

const CountryFlag = ({
  size = { width: WIDTH, height: HEIGHT },
  country,
}: Props) => {
  const isSquare = country === 'CH';

  if (!country) {
    return null;
  }

  return (
    <Image
      $width={isSquare ? size.height : size.width}
      $height={size.height}
      src={getFlagURIByCountryCode(country)}
    />
  );
};

export default memo(CountryFlag);
